/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Apply_User_TitleInputs */

const en_template_apply_user_title = /** @type {(inputs: Template_Apply_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply template?`)
};

const de_template_apply_user_title = /** @type {(inputs: Template_Apply_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage anwenden?`)
};

/**
* | output |
* | --- |
* | "Apply template?" |
*
* @param {Template_Apply_User_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const template_apply_user_title = /** @type {((inputs?: Template_Apply_User_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Apply_User_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_apply_user_title(inputs)
	return de_template_apply_user_title(inputs)
});